import React, { useEffect, useState } from "react";
import Modal from "../ui/Modal";
import { toast } from "react-toastify";
import CheckBox from "../ui/components/CheckBox";

const FilterHeadersDialog = ({
  open,
  setOpen,
  activeCols,
  setActiveCols,
  className = "max-w-2xl",
  className2 = "grid grid-cols-2 gap-2 items-center justify-between"
}) => {


const updateShowStateById = (venta) => {
  setActiveCols(prevHeaders =>
    prevHeaders.map(header =>
      header.id === venta.id ? { ...header, show: !venta.show } : header
    )
  )
};

  return (

    <Modal // Modal de filtros de columnas
      activeModal={open}
      onClose={() => {setOpen(false)}}
      title="Columnas activas"
      className={className}
      centered
    >
      <div className="flex flex-col gap-4">
        <div className={className2}>
          {activeCols
            .map((col) => (
              <div key={col.id} className="flex flex-row items-center justify-start gap-2">
                <CheckBox
                  checked={col.show}
                  onChange={() => updateShowStateById(col)}
                />
                <span className="text-xs font-semibold text-gray-700">{col.name || col.value}</span>
              </div>
            ))
          }
        </div>
      </div>

    </Modal>
  );
};

export default FilterHeadersDialog;